import { jsx } from "panel";
import { AuthContainerEl } from "common/widgets/auth-container";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { AuthSignUpFormEl } from "media/js/auth/signup/forms/auth-signup-form";
import { AuthBanners } from "../mixin/auth-banners";
import { AuthInvitationFormEl } from "./forms/auth-invitation-form";
export function template() {
  const {
    alreadyInvitedError,
    attemptingNonceValidation,
    defaultFormValues,
    isInvited
  } = this.state;
  return /* @__PURE__ */ jsx(AuthContainerEl, { "data-sentry-element": "AuthContainerEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".auth-form", attrs: {
    slot: "auth-form-slot"
  } }, attemptingNonceValidation ? /* @__PURE__ */ jsx("div", { sel: ".spinner-wrapper" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    size: SpinnerSize.Large
  } })) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(AuthBanners, { error: this.attr("already-invited-error") || alreadyInvitedError }), isInvited ? /* @__PURE__ */ jsx(AuthInvitationFormEl, { attrs: this.helpers.getInvitationFormAttributes(), props: {
    defaultFormValues
  }, on: {
    alreadyInvitedError: (ev) => this.helpers.handleAlreadyInvitedError(ev),
    signUpSuccess: this.helpers.handleSignUpSuccess
  } }) : /* @__PURE__ */ jsx(AuthSignUpFormEl, { attrs: this.helpers.getSignupFormAttributes(), props: {
    defaultFormValues
  }, on: {
    alreadyInvitedError: (ev) => this.helpers.handleAlreadyInvitedError(ev),
    signUpSuccess: this.helpers.handleSignUpSuccess
  } }))));
}
